import Vue from 'vue';

import VueSplitText from '~/directives/split-text';
Vue.use(VueSplitText);

// import ListMenu from '@/components/ListMenu';
// Vue.component('list-menu', ListMenu);
